import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-jump-backward",
  "use": "icon-si-glyph-jump-backward-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-jump-backward\" id=\"icon-si-glyph-jump-backward\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1239</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g fill=\"#434343\">\n            <path d=\"M14.994,1 C14.994,0.447 14.552,0 14.005,0 L12.026,0 C11.479,0 11.036,0.447 11.036,1 L11.036,15 C11.036,15.553 11.479,16 12.026,16 L14.005,16 C14.552,16 14.994,15.553 14.994,15 L14.994,1 L14.994,1 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M0.438,9.052 C-0.142,8.471 -0.142,7.53 0.438,6.948 L6.882,0.506 C7.463,-0.076 8.985,-0.333 8.985,1.506 L8.985,14.494 C8.985,16.395 7.464,16.076 6.882,15.495 L0.438,9.052 L0.438,9.052 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-jump-backward.svg
// module id = NvMd
// module chunks = 62